import type { Area } from 'react-easy-crop'

export interface CropImageOptions {
  /** 原图 MIME。PNG 保留透明，其余导出 JPEG。 */
  mime?: string
  width?: number
  height?: number
  quality?: number
}

function loadImage(src: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const image = new Image()
    image.onload = () => resolve(image)
    image.onerror = () => reject(new Error('crop image failed'))
    image.src = src
  })
}

/** 按像素裁剪框导出图片。 */
export async function cropImageToDataUrl(
  src: string,
  area: Area,
  options: CropImageOptions = {},
): Promise<string> {
  const image = await loadImage(src)
  const width = options.width ?? 512
  const height = options.height ?? width
  const canvas = document.createElement('canvas')
  canvas.width = width
  canvas.height = height
  const context = canvas.getContext('2d')
  if (!context) throw new Error('crop canvas failed')
  if (area.width <= 0 || area.height <= 0) throw new Error('crop area failed')
  // 缩小后裁剪框会超出原图，按目标位置绘制，框外留空。
  const scaleX = width / area.width
  const scaleY = height / area.height
  context.drawImage(
    image,
    -area.x * scaleX,
    -area.y * scaleY,
    image.naturalWidth * scaleX,
    image.naturalHeight * scaleY,
  )
  const mime = options.mime === 'image/png' ? 'image/png' : 'image/jpeg'
  return canvas.toDataURL(mime, options.quality ?? 0.92)
}

/** 以 `size` 为长边，按宽高比计算导出尺寸。 */
export function cropOutputSize(aspect: number, size: number): { width: number; height: number } {
  if (aspect >= 1) return { width: size, height: Math.max(1, Math.round(size / aspect)) }
  return { width: Math.max(1, Math.round(size * aspect)), height: size }
}
